export function finalizeOpenIntervals(s, nowMs, options) {
  const close = !!(options && options.close);
  finalizeCurrentPage(s, nowMs, { close });
  finalizeVisibleSections(s, nowMs, { close });
  finalizeActiveForms(s, nowMs, { close });
  finalizeActiveFields(s, nowMs, { close });
}

export function finalizeCurrentPage(s, nowMs, options) {
  if (!s || !s.currentPageKey || s.currentPageEnteredAt <= 0) return;

  const page = s.pages.get(s.currentPageKey);
  if (page) page.duration_ms += Math.max(0, nowMs - s.currentPageEnteredAt);
  if (options && options.close) s.currentPageEnteredAt = 0;
  else s.currentPageEnteredAt = nowMs;
}

export function finalizeVisibleSections(s, nowMs, options) {
  if (!s || !s.sections) return;

  for (const sec of s.sections.values()) {
    if (!sec.runtime.currentlyVisible || sec.runtime.enteredAt <= 0) continue;

    sec.time_total_ms += Math.max(0, nowMs - sec.runtime.enteredAt);
    if (sec.runtime.lastActivityAt > 0) {
      sec.reading_time_ms += Math.max(0, sec.runtime.lastActivityAt - sec.runtime.enteredAt);
    }

    if (options && options.close) {
      sec.runtime.currentlyVisible = false;
      sec.runtime.enteredAt = 0;
      sec.runtime.pauseStartedAt = 0;
    } else {
      sec.runtime.enteredAt = nowMs;
      sec.runtime.lastActivityAt = nowMs;
    }
  }
}

export function finalizeActiveForms(s, nowMs, options) {
  if (!s || !s.forms) return;

  for (const form of s.forms.values()) {
    if (!form.runtime.currentlyFocused) continue;

    if (form.runtime.activeSince > 0) {
      form.active_time_on_form_ms += Math.max(0, nowMs - form.runtime.activeSince);
    }
    if (form.runtime.firstFocusAt > 0) {
      form.time_on_form_ms = Math.max(form.time_on_form_ms, nowMs - form.runtime.firstFocusAt);
    }

    if (options && options.close) {
      form.runtime.currentlyFocused = false;
      form.runtime.activeSince = 0;
      form.runtime.firstFocusAt = 0;
      form.runtime.lastFocusOutAt = nowMs;
    } else {
      form.runtime.activeSince = nowMs;
      if (form.time_on_form_ms > 0) form.runtime.firstFocusAt = nowMs - form.time_on_form_ms;
    }
  }
}

export function finalizeActiveFields(s, nowMs, options) {
  if (!s || !s.fields) return;

  for (const field of s.fields.values()) {
    if (!field.runtime.currentlyFocused || field.runtime.lastFocusInAt <= 0) continue;
    if (field.focus_duration_ms != null) {
      field.focus_duration_ms += Math.max(0, nowMs - field.runtime.lastFocusInAt);
    }

    if (options && options.close) {
      field.runtime.currentlyFocused = false;
      field.runtime.lastFocusInAt = 0;
      field.runtime.lastFocusOutAt = nowMs;
    } else {
      field.runtime.lastFocusInAt = nowMs;
    }
  }
}
